import Skeleton from '@mui/material/Skeleton';

export function MapSkeleton() {
	return (
		<div className="flex w-full h-full flex-col items-center">
			<div className="w-full h-full bg-gray-200 rounded-lg">
				<Skeleton
					variant="rectangular"
					className="w-full h-full rounded-lg"
					sx={{ borderRadius: '12px' }}
				/>
			</div>
		</div>
	);
}
